const BASE_URL = `${process.env.REACT_APP_API_URL}/rj/bus`;

// Helper for HTTP requests
async function request(endpoint, options = {}) {
  const response = await fetch(`${BASE_URL}${endpoint}`, {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'API Request Failed');
  }

  return data;
}

export const api = {
  // Fetch everything (People, Buses, Assignments) for a specific event
  getData: async (eventId = 1) => {
    // We use the /data endpoint which returns { people, buses, assignments (grouped) }
    // Or we could fetch in parallel 3 requests. 
    // The previous implementation of /data returned [people, buses, assignments] array structure.
    // Let's check api-routes/rj/bus/data.js structure again.
    // It returns: res.status(200).json({ code: 200, data: { people, buses, assignments } });
    const res = await request(`/data?event=${eventId}`);
    return res.data;
  },

  getPeople: async (eventId = 1) => {
    const res = await request(`/person?event=${eventId}`);
    return res.data;
  },

  getBuses: async (eventId = 1) => {
    const res = await request(`/bus?event=${eventId}`);
    return res.data;
  },

  getAssignments: async (eventId = 1) => {
    const res = await request(`/assign?event=${eventId}`);
    return res.data;
  },

  // Assign person to bus
  assignPerson: async (busId, personId) => {
    return request('/assign', {
      method: 'POST',
      body: JSON.stringify({ busId, personId }),
    });
  },

  // Remove person from bus
  removeAssignment: async (busId, personId) => {
    return request('/assign', {
      method: 'DELETE',
      body: JSON.stringify({ busId, personId }),
    });
  },

  // Endpoint de warnings
  getWarnings: async (eventId = 1) => {
    const res = await request(`/warnings?event=${eventId}`);
    return res.data;
  },

  // Admin Methods
  createEvent: async (name, id) => {
    return request('/event', {
      method: 'POST',
      body: JSON.stringify({ name, id }),
    });
  },

  getEvents: async () => {
    const res = await request('/event');
    return res.data;
  },

  createBus: async (name, capacity, type, eventId) => {
    return request('/bus', {
      method: 'POST',
      body: JSON.stringify({ name, capacity, type, event: eventId }),
    });
  },

  createPerson: async (name, lastNames, need, familyId, eventId) => {
    return request('/person', {
      method: 'POST',
      body: JSON.stringify({
        name,
        lastNames,
        need,
        family: familyId || null,
        event: eventId
      }),
    });
  },

  createFamily: async (name, eventId, peopleIds = []) => {
    return request('/family', {
      method: 'POST',
      body: JSON.stringify({ name, event: eventId, peopleIds }),
    });
  },

  getFamilies: async (eventId) => {
    const query = eventId ? `?event=${eventId}` : '';
    const res = await request(`/family${query}`);
    return res.data;
  },

  resetBus: async (busId) => {
    return request('/reset', {
      method: 'POST',
      body: JSON.stringify({ busId }),
    });
  },

  deleteBus: async (busId) => {
    return request('/bus', {
      method: 'DELETE',
      body: JSON.stringify({ busId }),
    });
  }
};
